import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

// get projects for show on admin dashboard

export const addAdQuatation = createAsyncThunk(
    "/admin/create-admin-quotation",
    async (payload) => {
        try {
            const myurl = `${V_URL}/believe/create-quotation`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            // console.log(data, "adminGetEmployee response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const addAdQuatationSlice = createSlice({
    name: "addAdQuatation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addAdQuatation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addAdQuatation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addAdQuatation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default addAdQuatationSlice.reducer;
